import CodeMirror from '@uiw/react-codemirror';
import { StreamLanguage } from '@codemirror/language';
import { shell } from '@codemirror/legacy-modes/mode/shell';
import { python } from '@codemirror/lang-python';
import { javascript } from '@codemirror/lang-javascript';
import { oneDark } from '@codemirror/theme-one-dark';
import { EditorView } from '@codemirror/view';
import type { Extension } from '@codemirror/state';

function languageExtension(language: string): Extension {
  if (language === 'python') return python();
  if (language === 'javascript') return javascript();
  return StreamLanguage.define(shell);
}

export function CodeEditor({ value, language, onChange, readOnly = false, height = '260px' }: {
  value: string;
  language: string;
  onChange: (value: string) => void;
  readOnly?: boolean;
  height?: string;
}) {
  return (
    <div className="code-editor">
      <CodeMirror
        value={value}
        height={height}
        theme={oneDark}
        readOnly={readOnly}
        extensions={[languageExtension(language), EditorView.lineWrapping]}
        onChange={onChange}
        basicSetup={{
          lineNumbers: true,
          foldGutter: true,
          highlightActiveLine: true,
          bracketMatching: true,
          closeBrackets: true,
          autocompletion: true,
        }}
      />
    </div>
  );
}
